import { Mesh, Object3D } from "three";
import { waitTill } from "../util/Wait";
import { fetchMaterialObjectMap } from "../util/ThreeUtil";
import { logger } from "../util/Logger";

const cacheMap: any = {};
const log = false;

export interface Loader {
  load(usl: string, options?: {}): any;
}
export class LoaderManager {
  private _loader: Loader;

  constructor(loader: Loader) {
    this._loader = loader;
  }

  async load(url: string, options?: {}, clone = true) {
    if (!url || url === "") return undefined;

    log && logger.info("load begins for ", url);
    if (cacheMap[url] && cacheMap[url].done && cacheMap[url].asset) {
      log && logger.info("returned from cache for ", url);
      return clone
        ? cloneAsset(cacheMap[url].asset, true)
        : cacheMap[url].asset;
    }

    if (cacheMap[url] && !cacheMap[url].done) {
      log && logger.info("waiting for queue for ", url);
      await waitTill(() => {
        return cacheMap[url].done;
      });
      log && logger.info("queue ended, returning  for ", url);
      return clone
        ? cloneAsset(cacheMap[url].asset, true)
        : cacheMap[url].asset;
    }

    cacheMap[url] = { done: false, asset: null };

    log && logger.info("Download begins  for ", url);
    const asset = await this._loader.load(url, options);
    log && logger.info("Download ends  for ", url);

    if (asset) {
      log && logger.info("load ends successfully for ", url);
      cacheMap[url].asset = asset;
      cacheMap[url].done = true;
      return asset.clone();
    }

    log && logger.info("load ends in error for ", url);
    cacheMap[url] = undefined;
    return undefined;
  }
}

export function clearAssetCache() {
  for (const key in cacheMap) {
    if (cacheMap[key] != null && cacheMap[key].asset instanceof Object3D) {
      cacheMap[key].asset?.traverse((child: any) => {
        child.geometry?.dispose();
        child.material?.dispose();
      });
      cacheMap[key].asset?.removeFromParent();
      cacheMap[key] = undefined;
    }
  }
}

export function cloneAsset(object: any, rec = true) {
  if (object instanceof Object3D) {
    const objectClone = object.clone(rec);
    const map = fetchMaterialObjectMap(objectClone);
    map.entries().forEach((entry) => {
      const m = entry[0].clone();
      entry[1].forEach((o) => ((o as Mesh).material = m));
    });
    return objectClone;
  }
  return object.clone(rec);
}
